export default __webpack_public_path__ + "70235349b672dff8c79914f041717eb5.svg";